import React from 'react'

import { AsideSection } from '../AsideSection'
import { MedicamentosCard } from './MedicamentosCard'

export interface MedicamentosSectionProps {
  prontuarioId: ID
  dataAtendimento: Instant
}

export function MedicamentosSection(props: MedicamentosSectionProps) {
  return (
    <AsideSection title='Medicamentos em uso' type='clickable'>
      <MedicamentosCard {...props} />
    </AsideSection>
  )
}
